import dayjs from 'dayjs';

/**
 * mss-curator `DiscountCouponButton`과 동일한 키·localStorage 스키마.
 * 노출 정책: 하루 최초 접근 시 1회 3초 노출, 자정(로컬) 기준 리셋.
 */
export const CURATOR_COUPON_TOOLTIP_STORAGE_KEY = 'curator_shop_coupon_tooltip';

const getEndOfToday = (): number => dayjs().endOf('day').valueOf();

export const isCuratorCouponTooltipAlreadyShownToday = (): boolean => {
  try {
    const stored = localStorage.getItem(CURATOR_COUPON_TOOLTIP_STORAGE_KEY);
    if (!stored) {
      return false;
    }
    const { shown, expiry } = JSON.parse(stored) as { shown?: boolean; expiry?: number };
    if (typeof expiry !== 'number' || dayjs().valueOf() > expiry) {
      return false;
    }
    return shown === true;
  } catch {
    return false;
  }
};

export const markCuratorCouponTooltipShownToday = (): void => {
  try {
    localStorage.setItem(
      CURATOR_COUPON_TOOLTIP_STORAGE_KEY,
      JSON.stringify({
        shown: true,
        expiry: getEndOfToday(),
      }),
    );
  } catch {
    // ignore quota / private mode
  }
};
